export default (params) => ({
  trigger: {
    name: 'service_accessory_overlays.select_video_explanation',
    params: params,
  },
  config: {
    schema: {
      subject_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        subject_type: 'item',
        sub_feature: 'wall_mount_selector_video',
      },
    },
  },
});
